export function safeRedirect(targetPath: unknown): boolean {
  if (!targetPath || typeof targetPath !== "string") {
    return false;
  }

  if (/^https?:\/\//i.test(targetPath)) {
    return false;
  }

  if (targetPath.startsWith("//")) {
    return false;
  }

  if (!targetPath.startsWith("/")) {
    return false;
  }

  window.location.href = targetPath;
  return true;
}
